module.exports = __webpack_public_path__ + "img/doctors-cuate.49b257d8.svg";